import React, { FunctionComponent } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import NotificationSystem from 'rc-notification'
import { Link } from 'react-router-dom'
import Alert from 'Shared/components/Alert'
import { FullWideNotification } from 'Shared/components/Notification'
import { settings } from 'Router/routes'
import { sendEmailToConfirmAccount } from 'Redux/actions/auth'
import { StyledDottedBtnOrange, StyledDottedBtn } from './styles'

let notification: {
  notice: (arg0: {
    content: JSX.Element
    position: string
    duration: number
    closable: boolean
    style: { left: number; top: number }
    className: string
  }) => void
} | null = null

const showNotification = (message: string) => {
  // @ts-ignore
  notification.notice({
    content: <FullWideNotification color="success" message={message} />,
    position: 'full',
    duration: 3,
    closable: true,
    style: { left: 0, top: 60 },
    className: `ltr-support`,
  })
}

type EmailNotConfirmedAlertProps = {
  email: string
  isEmailBounced: boolean
}

const EmailNotConfirmedAlert: FunctionComponent<EmailNotConfirmedAlertProps> = ({
  email,
  isEmailBounced,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleSendEmail = () => {
    dispatch(sendEmailToConfirmAccount())
    NotificationSystem.newInstance(
      { style: { top: 65 } },
      (
        // eslint-disable-next-line no-return-assign
        n: {
          notice: (arg0: {
            content: JSX.Element
            position: string
            duration: number
            closable: boolean
            style: { left: number; top: number }
            className: string
          }) => void
        } | null
      ) => (notification = n)
    )
    showNotification(t('notification.checkEmail'))
  }

  const setErrorMessage = () => {
    if (isEmailBounced) {
      return (
        <Alert color="danger" icon>
          <div>
            <div className="alert__text">
              {t('campaignsPage.bouncedEmail')}
              <br />
              {t('campaignsPage.bouncedEmailSecond')}&nbsp;
            </div>
            <Link className="danger__btn" to={`${settings}/email`}>
              {t('campaignsPage.clickHere')}
            </Link>
          </div>
        </Alert>
      )
    }
    if (email) {
      return (
        <Alert color="warning" icon>
          <div className="alert__text">
            <div className="alert__title">
              {t('createCampaignPage.emailConfirmation')}
            </div>
            <div>
              {t('createCampaignPage.checkEmail')} {email}{' '}
              {t('createCampaignPage.andСlickСonfirmationLink')}
              &nbsp;{t('campaignsPage.emailAccess')}
              <Link className="warning__btn" to={`${settings}/email`}>
                {t('campaignsPage.here')}
              </Link>
            </div>
          </div>

          <StyledDottedBtnOrange onClick={handleSendEmail}>
            {t('campaignsPage.sendAgain')}
          </StyledDottedBtnOrange>
          <StyledDottedBtn to={`${settings}/email`}>
            {t('campaignsPage.changeE-mail')}
          </StyledDottedBtn>
        </Alert>
      )
    }
    return (
      <Alert color="warning" icon>
        <p>
          {t('campaignsPage.addEmail')}
          <Link className="warning__btn" to={`${settings}/email`}>
            {t('campaignsPage.here')}
          </Link>
        </p>
      </Alert>
    )
  }

  return <>{setErrorMessage()}</>
}

export default EmailNotConfirmedAlert
